import { DroppableContainer } from './DroppableContainer';
import { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { rectSortingStrategy, SortableContext } from '@dnd-kit/sortable';
import { WORD_BANK } from '../../utils';
import { SortableItem1 } from './SortableItem';

interface WordBankI {
  taskId: string;
  items: { WORD_BANK: { items: string[]; showingItems: { value: string; id: number }[] } };
  minW: number;
}

export const WordBank: FC<WordBankI> = ({ taskId, items, minW }) => {
  return (
    <Box p='2' mt='3' borderWidth='2px' borderRadius='lg' sx={{ width: '100%' }}>
      <Text
        fontSize='md' // make slightly smaller than other text
        color='gray.600'>
        Drag items from the box to the blanks above
      </Text>
      <SortableContext items={items[WORD_BANK].items} strategy={rectSortingStrategy}>
        <DroppableContainer
          // taskId={taskId}
          minW={minW}
          id={WORD_BANK}
          items={items[WORD_BANK].items}
          style={{
            // display: 'grid',
            // gridAutoRows: 'max-content',
            // gridTemplateColumns: 'repeat(2, 1fr)',
            // gridGap: '10px',
            // border: 'none',
            // margin: '0',
            display: 'flex',
            gridAutoRows: 'max-content',
            flexWrap: 'wrap',
            border: 'none',
            margin: '0',
          }}>
          {items[WORD_BANK].showingItems
            .filter((e) => !!e.value && e.value !== '')
            .map((value: { value: string; id: number }) => {
              return (
                <SortableItem1
                  minW={minW}
                  key={value.id}
                  isMap={false}
                  value={value.value}
                  id={value.id}
                  taskId={taskId}
                />
              );
            })}
        </DroppableContainer>
      </SortableContext>
    </Box>
  );
};

// Simple clickable word bank (no drag) for single-blank selection scenarios
export const ClickWordBank: FC<{ items: string[]; minW?: number; onSelect: (v: string) => void; label?: string }>= ({ items, minW = 80, onSelect, label }) => {
  return (
    <Box p='2' mt='3' borderWidth='2px' borderRadius='lg' sx={{ width: '100%' }}>
      <Text fontSize='md' color='gray.600'>
        {label ?? 'Click a word to fill the blank'}
      </Text>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', mt: 2 }}>
        {items.filter((e) => !!e && e !== '').map((value: string, idx: number) => (
          <Box
            key={idx}
            as='button'
            onClick={() => onSelect(value)}
            sx={{
              minWidth: minW + 'px',
              minHeight: '50px',
              borderWidth: '1px',
              borderRadius: 'md',
              px: 3,
              py: 2,
              cursor: 'pointer',
              bg: 'gray.50',
              _hover: { bg: 'gray.100' },
            }}
          >
            {value}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
